<template>
  <ul class="nav nav-tabs nav-tabs-custom nav-success mb-3" role="tablist">
    <li class="nav-item" v-for="(status, index) in statuses" :key="index">
      <a class="nav-link All py-3" :class="activeStatus === index ? 'active' : ''" @click="$emit('setOrderStatus', index)" data-bs-toggle="tab" id="All" href="#" role="tab" aria-selected="true">
        {{status.label}}
        <span class="badge bg-danger align-middle ms-1">{{status.count}}</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "statuses.vue",
  props: ['statuses'],
  data() {
    return {
      activeStatus: 'total',
    }
  }
}
</script>

